import * as React from 'react'
import { boxShadows } from '@eversports/design-tokens/box-shadows'
import Box from '@eversports/klimt-primitives/Box'

const BottomFixedSection = ({ children }: React.PropsWithChildren<unknown>) => {
  return (
    <Box
      sx={{
        padding: 4,
        zIndex: 3,
        bottom: 0,
        backgroundColor: 'white',
        position: 'fixed',
        width: '100%',
        border: '1px solid',
        borderColor: 'lightgray',
        boxShadow: boxShadows.default,
        display: { xs: 'flex', md: 'none' },
      }}
    >
      {children}
    </Box>
  )
}

export default BottomFixedSection
